module.exports = __webpack_public_path__ + "assets/img/returnBtn-5da8c043.png";